import { render, staticRenderFns } from "./trainingHeader.vue?vue&type=template&id=7b4bfc66&scoped=true&"
import script from "./trainingHeader.vue?vue&type=script&lang=js&"
export * from "./trainingHeader.vue?vue&type=script&lang=js&"
import style0 from "./trainingHeader.vue?vue&type=style&index=0&id=7b4bfc66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4bfc66",
  null
  
)

export default component.exports